// home/hero-front.tsx
'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import PriceTrackingHero from '@/components/component/home/price-tracking-hero';
import { motion } from 'framer-motion';

export function HeroFront({
  setIsSticky,
}: {
  setIsSticky: (value: boolean) => void;
}) {
  const router = useRouter();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsSticky(scrollPosition > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [setIsSticky]);

  const handleTryItFree = () => {
    router.push('/dashboard');
  };

  return (
    <section className="relative -mt-14">
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
        {/* Abstract geometric shapes */}
        <motion.div
          className="absolute top-40 left-10 w-64 h-64 rounded-full bg-blue-500/5 blur-3xl"
          animate={{
            scale: [1, 1.1, 1],
            opacity: [0.3, 0.5, 0.3],
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        />
        <motion.div
          className="absolute bottom-40 right-10 w-96 h-96 rounded-full bg-indigo-500/5 blur-3xl"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.2, 0.4, 0.2],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            repeatType: 'reverse',
            delay: 2,
          }}
        />
      </div>

      <PriceTrackingHero onTryItFree={handleTryItFree} />
    </section>
  );
}
